<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left> 训练督导详细信息 </template>
    <template v-slot:nav_right v-if="supervisionInfo.supervisorySignatoriesUuids">
      <div  class="yioks_btn" @click="download">下载训练督导评估表</div>
      <!--<div  class="yioks_btn" @click="isUpload = true" v-if="userRole === 'expert'">签字并上传训练督导评估表</div>-->
      <!--<div  class="yioks_btn" v-if="['admin','system'].includes(userRole) && supervisionInfo.fileUrl" @click="lookFile">查看训练督导评估表</div>-->
    </template>
    <div v-if="!isLoading" class="scroll_wrap">
      <vue-scroll>
        <div class="info_item">
          <div class="base_info">
            <div class="info">
              <div class="col">
                <span>单位：{{supervisionInfo.organShortName}}-{{supervisionInfo.youthShortName}}</span>
                <span>球队 ：{{supervisionInfo.squadShortName}}</span>
              </div>
              <div class="col">
                <span>训练主题：{{supervisionInfo.trainTitle || '--'}}</span>
                <span>训练时间：{{ supervisionInfo.supervisoryTime  | time(true)}} 至 {{ supervisionInfo.supervisoryEndTime  | time(true)}}</span>
              </div>
              <div class="col">
                <span>性别：{{supervisionInfo.gender | squadPlayerSex}}</span>
                <span>教练员 ：{{supervisionInfo.trainCoach || '无'}}
                  <template v-if="!supervisionInfo.trainCoach">
                    （备注：{{supervisionInfo.otherCoach || '--'}}）
                  </template>
                </span>
              </div>
              <div class="col" v-if="supervisionInfo.trainCoach">
                <span>备注：{{supervisionInfo.otherCoach || '--'}}</span>
              </div>
              <fieldset class="vita-form-fieldset" style="border: 1px dashed  white;padding: 10px ; margin: 0 15px 15px;"  >
                <legend>队伍</legend>
                <div class="col titleAndInfo">
                  <span class="titleTitleSquad">人员（人数，队伍情况）：</span>
                  <span>{{supervisionInfo.squadPerson}}</span>
                </div>
                <div class="col titleAndInfo">
                  <span class="titleTitleSquad">场地（使用时间，区域）：</span>
                  <span>{{supervisionInfo.squadVenue}}</span>
                </div>
                <div class="col titleAndInfo">
                  <span class="titleTitleSquad">队伍架构（教练配置情况）：</span>
                  <span>{{supervisionInfo.squadDisposition}}</span>
                </div>
                <div class="col">
                  <span class="titleTitleSquad">基本信息（等级，培训，成绩）：</span>
                  <span>{{supervisionInfo.squadBaseInfo}}</span>
                </div>
              </fieldset>

              <fieldset class="vita-form-fieldset" style="border: 1px dashed  white;padding: 10px ; margin: 0 15px 15px;"  >
                <legend>教练</legend>
                <div class="col titleAndInfo">
                  <span>个人形象（精神面貌，服饰，仪表、态度）：</span>
                  <span>{{supervisionInfo.coachPersonalImage}}</span>
                </div>
                <div class="col titleAndInfo">
                  <span >教案设计（主题、针对性、真实性、合理性）：</span>
                  <span>{{supervisionInfo.coachPlanDevise}}</span>
                </div>
                <div class="col titleAndInfo">
                  <span >组织安排（时间安排，场地布置，器材使用）：</span>
                  <span>{{supervisionInfo.coachArrangement}}</span>
                </div>
                <div class="col titleAndInfo">
                  <span >观察指导（发现、洞察，重组，改进、效果）：</span>
                  <span>{{supervisionInfo.coachObservational}}</span>
                </div>
                <div class="col">
                  <span >沟通交流（提问、引导、讲解，肢体语言及示范）：</span>
                  <span>{{supervisionInfo.coachCommunication}}</span>
                </div>
              </fieldset>

              <fieldset class="vita-form-fieldset" style="border: 1px dashed  white;padding: 10px ; margin: 0 15px 15px;"  >
                <legend></legend>
                <div class="col titleAndInfo">
                  <span class="titleTitle">机构现状：</span>
                  <span>{{supervisionInfo.youthBaseStatus}}</span>
                </div>
                <div class="col titleAndInfo">
                  <span class="titleTitle">工作亮点：</span>
                  <span >{{supervisionInfo.workHighlights}}</span>
                </div>
                <div class="col titleAndInfo">
                  <span class="titleTitle">问题及建议：</span>
                  <span>{{supervisionInfo.questionsSuggestions}}</span>
                </div>
                <div class="col">
                  <span class="titleTitle">综合评价：</span>
                  <span >{{supervisionInfo.comprehensive}}</span>
                </div>
              </fieldset>
              <div class="col">
                <span>填写人 ：{{supervisionInfo.trainSupervisory}}</span>
                <span>填写日期 ：{{supervisionInfo.writeTime | time}}</span>
              </div>
              <div class="col">
                <span>签字人 ：{{supervisionInfo.supervisorySignatories || '--'}}</span>
              </div>

            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
    <yioks-loading v-if="isLoading"></yioks-loading>
    <template v-if="isUpload">
      <upload-dialog
        :isOpen.sync="isUpload"
        :isEdit="isEditMode"
        :supervisionUuid="supervisionUuid"
        @closeDialogCallBackSupervisionTrain="handleUploadCallBack"
      ></upload-dialog>
    </template>
  </SubContent>
</template>

<script>
import supervision from "@/api/supervision"; // getPlayerInfo获取球员信息
import common from '@/api/common'
import storage from "@/utils/storage";
import {  squadPlayerSex } from '@/utils/yioks_filter'
import playImg from '@/assets/images/common/playImg.png'

export default {
  name: "ScoutRate",

  data() {
    return {
      playImg,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      isLoading: true,
      supervisionInfo: {},
      isUpload: false,
      isEditMode: false,
      downIng: false,
    };
  },

  components: {
    SubContent: () => import("@/components/layout/newSubContent"),
    "upload-dialog": () => import("@/views/supervisory/uploadSupervisionTrainReport"),
  },

  computed: {
    supervisionUuid() {
      const uuid = this.$route.query.supervisionUuid || "";
      return uuid;
    },
  },

  filters: {
    squadPlayerSex
  },

  mounted() {
    this.loadSupervisoryInfo();
  },

  methods: {
    download () {
      if (this.downIng) return
      this.downIng = true
      supervision.supervisoryTrainDownLoadPdf({ dataUuid: this.supervisionUuid }).then(res => {
        const { fileName, filePath } = res
        const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
        common.downfile(transferPath, fileName);
        this.downIng = false
      }).catch(err => {
        this.downIng = false
      })
    },
    // 提交弹窗回掉方法
    handleUploadCallBack(dialogStatus, confirmStatus) {
      this.isUpload = dialogStatus;
      if (confirmStatus) {
        if (!dialogStatus) {
          // this.changeQuery(true);

          this.isEditMode = false;
        } else {
          console.warn("call back error, dialog will be stay!");
        }
      } else {
      }

    },
    /* 获取球探报告详细信息 */
    loadSupervisoryInfo() {
      const uuid = this.supervisionUuid;
      supervision
        .getSupervisoryInfo(uuid)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return
          }
          this.supervisionInfo = res;
          this.isLoading = false;
        })
        .catch((err) => {
          console.error("异常", err);
        });
    },
    lookFile(){
      if (this.supervisionInfo.fileUrl) {
        window.open('http://kkfv.yioks.cn/onlinePreview?url='+encodeURIComponent(this.$Base64.encode(this.supervisionInfo.fileUrl)));
      }else{
        this.$message.error('评估表暂未上传');
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
.nav-right-btn
  font-size 18px
  padding 10px 15px
  display -webkit-box
  display -ms-flexbox
  display flex
  -webkit-box-align center
  -ms-flex-align center
  align-items center
  cursor pointer
  -webkit-user-select none
  -moz-user-select none
  -ms-user-select none
  user-select none
  margin-right 10px
  border 1px solid #fff
  &:hover
    background-color #4cd964
    border 1px solid #4cd964
.record-dialog
  color #000
  .title-text
    color #000
    font-size 24px
    border-bottom 1px solid #666
    padding-bottom 10px
.time-line-wrapper
  padding 0 15px
  .time-item
    display flex
    justify-content center
    align-items center
    margin-bottom 20px
    position relative
    &:first-child
      .line
        border-left none
    .line
      height 59%
      border-left 2px solid #666
      position absolute
      top -34px
      left 25px
    .item-left
      width 50px
      height 50px
      display flex
      justify-content center
      align-items center
      border-radius 50%
      border 1px solid #666
      text-align center
    .item-right
      font-size 16px
      width 90%
      margin-left 20px
      .time-content
        text-indent 2px
      .item-info
        min-height 62px
        border-radius 5px
        border 1px solid #ccc
        padding 12px
.focus-action-tips
  .tips-title-wrapper
    color #000
    font-size 24px
    padding-bottom 10px
    border-bottom 1px solid #666
  .focus-action-content
    font-size 16px
  .tips-text
    margin-bottom 10px
    display flex
    align-items center
  .footer-btns-wrapper
    width 60%
    margin 0 auto
    display flex
    justify-content space-around
    font-size 16px
.yioks-outline:focus
  outline-color #4cd964 !important
  border-color #4cd964 !important
.scroll_wrap {
  height: 100%;
  padding: 20px 0 10px 20px;
  box-sizing: border-box;
  overflow: hidden;

  .info_item {
    margin: 0 30px 30px 10px;
    .info_title {
      font-size: 20px;
      padding: 10px 0 20px;
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
        width: 26px;
      }
    }

    .base_info {
      border: 1px solid #FFF;
      display: flex;
      position relative
      .focus-tips{
        position absolute
        top 0
        right 0
        width 100px
        height 100px
        overflow hidden
        .tips-content{
          width 150px
          height 20px
          line-height 20px
          text-align center
          background-color red
          transform rotate(45deg)
          position absolute
          top 21px
          right -46px
        }
      }
      .info {
        flex: 1;
      }

      .col {
        /*border-bottom: 1px solid #FFF;*/
        // border-right 1px solid #FFF
        padding: 16px 15px;
        display: flex;
        justify-content: space-around;

        span {
          display: inline-block;
          width: 100%;
        }
        .titleTitle{
          width:15%
        }
        .titleTitleSquad{
          width:50%
        }

       /* &:last-child {
          border-bottom: 0;
        }*/
      }
      .titleAndInfo{
        border-bottom:1px dashed #FFF
      }
      .playerImg {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 120px;
          height: 120px;
          /* height 1.2rem */
          border-radius: 50%;
          padding: 10px;
        }

        p {
          text-align: center;
        }
      }
    }
  }
  .item_title{
    display flex
    align-items center
    font-size .2rem
    padding .4rem 0 .2rem
    margin 0 .3rem
    span{
      margin-left .4rem
      font-size .16rem
    }
    img{
      margin-right .1rem
    }
  }
  .trainPlan{
    display flex
    justify-content space-between
    flex-wrap wrap
    /*margin:0 .3rem;*/
    .planDetail{
      border 1px solid white
      width 100%
      .row{
        min-height 49px
        display flex
        align-items center
        border-bottom 1px solid white
        &:last-child{
          border-bottom none
        }
        .col{
          width:50%
          padding 0 10px 0 20px
          height 100%
          line-height 49px
          text-overflow:ellipsis;
          overflow:hidden;
          white-space:nowrap;
          &:first-child{
            border-right 1px solid white
          }
        }
      }
      .rowLine{
        padding:10px 10px 10px 20px
      }
    }
    .mediaDetail{
      background-color rgba(0, 0, 0, 0.7)
      border 1px solid white
      padding 20px
      width 400px
      display flex
      align-items center
      cursor pointer
      margin-bottom 20px
      .p_item{
        margin-bottom 10px
      }
    }
    .img{
      width 170px
      height 100px
      position relative
      .coverImg{
        width 100%
        height 100%
      }
    }
    .intro{
      padding-left 10px
      width:calc(100% - 170px);
      height 100px
      display flex
      flex-direction column
      justify-content space-between
    }
  }
}

.trainPlan {
  .planDetail {
    border: 1px solid white;
    width: 100%;
    display: flex;
    margin-bottom: 15px;

    .info {
      padding: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #FFF;

      p {
        padding-top: 10px;
      }

      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
    }

    .box-wrap {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    //   justify-content: space-around;
      justify-content: flex-start;
      padding: 10px 5px 0;

      .box {
        width: 90px;
        display: flex;
        margin: 0 10px 10px
        flex-direction: column;
        // border-right 1px solid #FFF
        // border 1px solid #FFF
        // margin-bottom: 10px;

        p {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 40px;
          text-align: center;
        }

        .content {
          border-top: 1px dashed #FFF;
        }

        .indicatorName {
          color: #4cd964;
        }
      }
    }
  }
}

.w240 {
  width: 240px;
}

.w500 {
  width: 500px;
}

.content-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="stylus">
.page-content {
  .el-steps--simple {
    background-color: rgba(0, 0, 0, 0);
  }

  .el-form-item__label {
    color: #fff;
    font-size: 16px;
  }
}
</style>
